import React, { useEffect, useMemo, useRef, useState } from 'react';
import './index.scss';
import { Button, Modal, notification } from 'tea-component';
import TransferTable from '@/pages/globalpedia/components/TransferTable';
import { useEditProjectDetailInfo } from '@gp/pages/Pipeline/ProjectDetails/GameDetail/components/TeamGameInformation/hooks/useInformation';
import { useBoolean, useDeepCompareEffect, useUpdate } from 'ahooks';
import { isEmpty } from 'lodash-es';
import { reportBtnOperationLog } from '@gp/utils/common';
interface TransferTableForwardProps {
  selectList: any[] | null;
}
interface IPropsSimilarModal<
  F = () => void,
  O = { [key in string]: string | undefined },
> {
  visible: boolean;
  close: F;
  similarData: O;
  allCountryFlag: O;
  gameInformationData: O;
  similarDataRefresh?: F;
  gameInformationDataRefresh?: F;
}

const SimilarModal = ({
  visible,
  close,
  similarData,
  allCountryFlag,
  gameInformationData,
  similarDataRefresh,
  gameInformationDataRefresh,
}: IPropsSimilarModal) => {
  const transferSelectListRef = useRef<TransferTableForwardProps>(null);
  const { runAsync } = useEditProjectDetailInfo('similarEdit');
  const { project_id, name, studio_entity_id } = gameInformationData || {};
  const [
    isDisabledBtn,
    { setTrue: setDisabledBtn, setFalse: setDisabledBtnFalse },
  ] = useBoolean(false);
  const upData = useUpdate();
  const handleOnChangeOk = async () => {
    const userSelectList = transferSelectListRef.current?.selectList;
    const platformIcon: { [keyName: string]: number } = {
      mobile: 1,
      pc: 2,
      console: 3,
    };
    const dataSource = userSelectList?.map((task) => ({
      competitor_unfied_id: task?.game_id,
      competitor_type: platformIcon?.[task?.entity_type] || 0,
    }));

    try {
      const params = {
        project_id,
        studio_id: studio_entity_id,
        list: dataSource,
      };
      await runAsync(params);
      similarDataRefresh?.();
      gameInformationDataRefresh?.();
      notification.success({
        description: 'Save success',
        duration: 1000,
      });
      close();
    } catch (error) {
      notification.error({
        description: 'Save failed. Please check the network',
        duration: 1000,
      });
    } finally {
      reportBtnOperationLog('DETAIL_PROJECT_DETAIL_SIMILAR_GAMES_EDIT_SUBMIT');
    }
  };
  useEffect(() => {
    if (
      isEmpty(similarData?.list) &&
      isEmpty(transferSelectListRef.current?.selectList)
    ) {
      setDisabledBtn();
    } else {
      setDisabledBtnFalse();
    }
  }, [upData, similarData?.list, transferSelectListRef.current?.selectList]);
  return (
    <Modal
      visible={visible}
      className="dbg-similar-modal"
      size={800}
      caption="Add Games"
      onClose={() => {
        close();
      }}
    >
      <Modal.Body>
        <TransferTable
          ref={transferSelectListRef}
          allCountryFlag={allCountryFlag}
          defaultData={similarData?.list}
          upData={upData}
          searchReportOperationLogBasicMsg={{
            query: '',
            extInfo: '510005', // 当前页面id
            clickId: '',
            uidType: 'game_code',
            uid: name,
          }}
        />
      </Modal.Body>
      <Modal.Footer>
        <Button
          type="primary"
          disabled={isDisabledBtn}
          onClick={handleOnChangeOk}
        >
          Confirm
        </Button>
        <Button
          type="weak"
          onClick={() => {
            close();
          }}
        >
          Cancel
        </Button>
      </Modal.Footer>
    </Modal>
  );
};

export default SimilarModal;
